import type { IssueRow } from "#app/lib/data";

/**
 * A partial Issue, standing in for a mutation's result until the server
 * answers. Apollo writes an optimistic result field by field and rolls the
 * whole write back on the response, so an object carrying only the fields
 * the mutation changes is valid at run time; the generated result type asks
 * for every field. This is the ONE place that gap is asserted. `__typename`
 * and `issueId` are the cache identity and are never optional.
 */
export function optimisticIssue(
  patch: Partial<Omit<IssueRow, "__typename">> & { issueId: string },
): IssueRow {
  return { __typename: "Issue", ...patch } as IssueRow;
}
